import { render, staticRenderFns } from "./CreditGroupList.vue?vue&type=template&id=5fc1761c&scoped=true&"
import script from "./CreditGroupList.vue?vue&type=script&lang=js&"
export * from "./CreditGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc1761c",
  null
  
)

export default component.exports